module.exports = __webpack_public_path__ + "img/20200307145649570.6321b5ae.jpg";